(function($){

    /**
     * Copyright 2012, Digital Fusion
     * Licensed under the MIT license.
     * http://teamdf.com/jquery-plugins/license/
     *
     * @author Sam Sehnert
     * @desc A small plugin that checks whether elements are within
     *       the user visible viewport of a web browser.
     *       can accounts for vertical position, horizontal, or both
     */
    var $w=$(window);
    $.fn.visible = function(partial,hidden,direction,container){

        if (this.length < 1)
            return false;

        // Set direction default to 'both'.
        direction = direction || 'both';

        var $t = this.length > 1 ? this.eq(0) : this,
            $container = (typeof container !== 'undefined' && container !== null) ? $(container) : $(),
            isContained = $container.length > 0,
            $c = isContained ? $container : $w,
            wPosition = isContained ? $c.position() : { top: 0, left: 0 },
            t = $t.get(0);

        if (!t)
            return false;

        if (!wPosition) {
            wPosition = { top: 0, left: 0 };
        }

        var vpWidth = isContained ? ($c.outerWidth() || $c.width() || 0) : (typeof $w.width === 'function' ? $w.width() : $w.outerWidth() || 0),
            vpHeight = isContained ? ($c.outerHeight() || $c.height() || 0) : (typeof $w.height === 'function' ? $w.height() : $w.outerHeight() || 0),
            clientSize = hidden === true ? t.offsetWidth * t.offsetHeight : true;

        if (typeof t.getBoundingClientRect === 'function'){

            // Use this native browser method, if available.
            var rec = t.getBoundingClientRect();

            if (!rec)
                return false;

            var containerRect = isContained && $c.length && typeof $c.get(0).getBoundingClientRect === 'function' ? $c.get(0).getBoundingClientRect() : null,
                topBoundary = isContained && containerRect ? containerRect.top : 0,
                bottomBoundary = isContained && containerRect ? containerRect.bottom : vpHeight,
                leftBoundary = isContained && containerRect ? containerRect.left : 0,
                rightBoundary = isContained && containerRect ? containerRect.right : vpWidth,
                tViz = rec.top >= topBoundary && rec.top < bottomBoundary,
                bViz = rec.bottom > topBoundary && rec.bottom <= bottomBoundary,
                lViz = rec.left >= leftBoundary && rec.left < rightBoundary,
                rViz = rec.right > leftBoundary && rec.right <= rightBoundary,
                vVisible = partial ? tViz || bViz : tViz && bViz,
                hVisible = partial ? lViz || rViz : lViz && rViz,
                vVisible = (rec.top < topBoundary && rec.bottom > bottomBoundary) ? true : vVisible,
                hVisible = (rec.left < leftBoundary && rec.right > rightBoundary) ? true : hVisible;

            if(direction === 'both')
                return clientSize && vVisible && hVisible;
            else if(direction === 'vertical')
                return clientSize && vVisible;
            else if(direction === 'horizontal')
                return clientSize && hVisible;
        } else {

            var position = $t.position();
            if (!position)
                return false;

            var viewTop = isContained ? $c.scrollTop() : $w.scrollTop(),
                viewBottom      = viewTop + vpHeight,
                viewLeft        = $c.scrollLeft(),
                viewRight       = viewLeft + vpWidth,
                _top            = position.top,
                _bottom         = _top + $t.height(),
                _left           = position.left,
                _right          = _left + $t.width(),
                compareTop      = partial === true ? _bottom : _top,
                compareBottom   = partial === true ? _top : _bottom,
                compareLeft     = partial === true ? _right : _left,
                compareRight    = partial === true ? _left : _right;

            if(direction === 'both')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop)) && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
            else if(direction === 'vertical')
                return !!clientSize && ((compareBottom <= viewBottom) && (compareTop >= viewTop));
            else if(direction === 'horizontal')
                return !!clientSize && ((compareRight <= viewRight) && (compareLeft >= viewLeft));
        }

        return false;
    };

})(jQuery);
